import React, { useState, useEffect } from "react";
import useResponsiveFlags from "../hooks/useResponsiveFlags";

export default function HiresDemoData({
  formData,
  updateFormData,
  errors,
  clearFieldError,
  disabled
}) {
  const { isMobile, isTablet, isDesktop } = useResponsiveFlags();

  const handleChange = (e) => {
    const { name, value } = e.target;
    clearFieldError(name);
      if (name === "bulkExpressionFile" || name === "fractionResultFile" || name === "token") {
        const [id, fileName] = value.split("|"); // Split the concatenated value
        updateFormData({ [name]: { id, value: fileName } }); // Update with object
      }
      // if (name === "fractionResultFile") {
      //   const [id, fileName] = value.split("|"); // Split the concatenated value
      //   updateFormData({ [name]: { id, value: fileName } }); // Update with object
      // }
      // if (name === "token") {
      //   const [id, fileName] = value.split("|"); // Split the concatenated value
      //   updateFormData({ [name]: { id, value: fileName } });
      // } 
      else {
        updateFormData({ [name]: value });
      }
  };
  const [tokens, setTokens] = useState([]);
  // useEffect(() => {
  //   const fetchTokens = async () => {
  //     try {
  //       const response = await fetch(
  //         `${process.env.REACT_APP_API_URL}/api/get-hires-token`,
  //         {
  //           method: "GET",
  //         credentials: "include",
  //           // headers: {
  //             // Authorization: `Bearer ${localStorage.getItem("token")}`,
  //           // },
  //         }
  //       ); // Replace with your API endpoint
  //       const data = await response.json();
  //       setTokens(data.items); // Assuming the API returns an array of tokens
  //     } catch (error) {
  //       console.error("Error fetching tokens", error);
  //     }
  //   };

  //   fetchTokens();
  // }, []);
  return (
    <>
       <div className="responsive-div">
        <div className="row">
 
          <div className="col-lg-3 mb-3">
          <p className="form-label">Select Demo Data</p>
          <span className="review-text sub-text">
            Explore with our pre-configured demo data to familiarize yourself
            with iSort&trade; functionality.
          </span>
          </div>

          <div className="col-lg-6">
          <div className="form-group">
          <label className="menu-options label-spacing">Mixture File*</label>
            <select
              name="bulkExpressionFile"
              value={
                `${formData.bulkExpressionFile.id}`
                  ? `${formData.bulkExpressionFile.id}|${formData.bulkExpressionFile.value}`
                  : ""
              }
              onChange={handleChange}
              className="form-select"
              required
            >
              <option value="" disabled>
                Select...
              </option>
              <option value={"2|Demo Mixture File for HiRes"}>
                Demo Mixture File for HiRes
              </option>
            </select>
            {errors.bulkExpressionFile && (
              <p className="error-text">{errors.bulkExpressionFile}</p>
            )}
          </div>

          <div className="form-group">
          <label className="menu-options label-spacing">Fraction Results File*</label>
            <select
              name="fractionResultFile"
              value={
                `${formData.fractionResultFile.id}`
                  ? `${formData.fractionResultFile.id}|${formData.fractionResultFile.value}`
                  : ""
              }
              onChange={handleChange}
              className="form-select"
              required
            >
              <option value="" disabled>
                Select...
              </option>
              <option value={"3|Demo Fraction file for HiRes"}>
                Demo Fraction Result file for HiRes
              </option>
            </select>
            {errors.fractionResultFile && (
              <p className="error-text">{errors.fractionResultFile}</p>
            )}
          </div>

          <div className="form-group">
          <label className="menu-options label-spacing">Token*</label>
            <select
              name="token"
              value={
                `${formData.token.id}`
                  ? `${formData.token.id}|${formData.token.value}`
                  : ""
              }
              onChange={handleChange}
              className="form-select"
              required
            >
              <option value="" disabled>
                Select...
              </option>
              {tokens.length > 0 ? (
                tokens.map((token) => (
                  <option key={token.id} value={`${token.id}|${token.token}`}>
                    {token.token} {/* Display token value */}
                  </option>
                ))
              ) : (
                <option disabled>No tokens available</option>
              )}
            </select>
            {errors.token && <p className="error-text">{errors.token}</p>}
          </div>
        </div>
      </div>


      {isDesktop && (<hr />)}
      


        <div className="row">
          <div className="col-lg-3 mb-3">
            <small className="review-text">
              Name this run (optional) to find your results easily later
            </small>
          </div>
          <div className="col-lg-6">
            <div className="form-group">
            <label className="menu-options label-spacing">Run Name</label>
              <input
                type="text"
                name="runName"
                value={formData.runName}
                onChange={handleChange}
                
              />
            </div>
          </div>
        </div>
      </div>
      <hr />
    </>
  );
}
